import { useNavigate } from "react-router";
import { ReactComponent as EditIcon } from "../../assets/icons/tables/edit-icon.svg";
import { ReactComponent as TrashIcon } from "../../assets/icons/tables/trash-icon.svg";
import { useUserProfileBadges } from "../../store/useUserProfileBadges";

export const BadgesTable = () => {
  /** Hooks */
  const { userProfileBadges, deleteUserProfileBadge } = useUserProfileBadges();
  const navigate = useNavigate();

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-base font-normal font-satoshi text-left rtl:text-right text-dark">
        <thead className="font-medium bg-gray-50">
          <tr>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Name
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Description
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Type
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Color
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Min drops
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Min value
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Item type
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Reward Droppies
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4 text-right">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {userProfileBadges?.map((badge) => (
            <tr key={badge?._id} className="bg-white border-b">
              <td className="px-2 sm:px-6 py-1 sm:py-4 whitespace-nowrap">
                {badge?.name}
              </td>
              <td className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4">
                {badge?.description}
              </td>
              <td className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4">
                {badge?.type}
              </td>
              <td className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4">
                <div
                  style={{ backgroundColor: badge?.color }}
                  className={`w-[15px] h-[15px] mr-1 cursor-pointer rounded`}
                />
              </td>
              <td className="px-2 sm:px-6 py-1 sm:py-4">{badge?.minDrops}</td>
              <td className="px-2 sm:px-6 py-1 sm:py-4">
                {Number(badge?.minValue ?? 0) / 100} €
              </td>
              <td className="px-2 sm:px-6 py-1 sm:py-4">
                {badge?.itemType?.name}
              </td>
              <td className="px-2 sm:px-6 py-1 sm:py-4">
                {badge?.rewardDroppies}
              </td>
              <td className="px-2 sm:px-6 py-1 sm:py-4 flex items-center justify-end cursor-pointer">
                <EditIcon
                  onClick={() =>
                    navigate(`/edit-user-profile-badge/${badge?._id}`)
                  }
                  className="mr-3 sm:mr-7"
                />
                <TrashIcon
                  onClick={() => {
                    const confirmDelete = window.confirm(
                      "Are you sure you want to delete this badge?"
                    );
                    if (confirmDelete) {
                      deleteUserProfileBadge(badge?._id as string);
                    }
                  }}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
